<template>
  <!-- 디자인 시스템: 재화(🥕 당근) 표시 pill. 아이콘/색/모양 고정, balance·mini만 노출. -->
  <div class="currency-pill" :class="{ mini, 'currency-pill--dark': isDark }" :title="title" @click="$emit('click')">
    <span class="currency-pill__emoji">🥕</span>
    <span v-if="!mini" class="currency-pill__count">{{ (balance || 0).toLocaleString() }}</span>
    <v-spacer v-if="!mini" />
    <v-icon v-if="!mini" small color="#c98a2e">mdi-plus-circle</v-icon>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";

export default {
  name: "AppCurrencyPill",
  mixins: [Themeable], // isDark(컨텍스트/앱 테마 상속) + dark/light prop 오버라이드
  props: {
    balance: { type: Number, default: 0 }, // 당근 잔액
    mini: { type: Boolean, default: false }, // 사이드바 접힘 → 이모지만
    title: { type: String, default: "" }, // 툴팁(예: 재화 상점 라벨)
  },
};
</script>

<style scoped>
/* 재화 칩 (🥕) */
.currency-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  cursor: pointer;
  background: linear-gradient(135deg, #fff4e0, #ffe6c2);
  border: 1px solid #f1c98a;
  box-shadow: 0 1px 4px rgba(201, 138, 46, 0.25);
  transition: filter 0.15s ease, transform 0.1s ease;
}
.currency-pill:hover {
  filter: brightness(1.04);
}
.currency-pill:active {
  transform: scale(0.98);
}
.currency-pill.mini {
  justify-content: center;
  padding: 6px 0;
}
.currency-pill__emoji {
  font-size: 16px;
  line-height: 1;
}
.currency-pill__count {
  font-weight: 700;
  color: #9a6a18;
  font-size: 14px;
}

/* ── 다크: 어두운 따뜻한 톤 pill + 밝은 골드 텍스트 ── */
.currency-pill--dark {
  background: linear-gradient(135deg, #3a2f1c, #2c2417);
  border-color: #5c4a2a;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
}
.currency-pill--dark .currency-pill__count {
  color: #f0c15a;
}
</style>
